import Image from "next/image";
import styles from "./FilterTag.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { cn } from "@utils/utils";

interface FilterTagProps {
  label: string;
  prefix?: string;
  onClick?: () => void;
  isActive?: boolean;
}

export default function FilterTag({
  label,
  prefix,
  onClick,
  isActive = false,
}: FilterTagProps) {
  return (
    <div
      className={cn(styles.filterTag, isActive ? styles.activeFilterTag : "")}
      onClick={onClick}
    >
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <span className={styles.label}>{label}</span>
      <Image
        loading="lazy"
        src={`${assetLoader()}/icons/Chevron_down_dark.svg`}
        alt={`${label} dropdown icon`}
        width={30}
        height={30}
        className={styles.icon}
      />
    </div>
  );
}
